import React from 'react';
import { FocusDashboard } from './FocusDashboard';

// Das alte AppleDashboard bleibt im Code erhalten (nicht mehr eingebunden),
// falls wir zurück wollen. Angezeigt wird jetzt das reduzierte Fokus-Dashboard.
export const DashboardShowcase: React.FC = () => {
  return <FocusDashboard />;
};